import React, { FC } from 'react';

import { AccountViewHeader } from '../../components/AccountViewHeader';
import AccountViewHeaderSkeleton from '../../components/AccountViewHeader/AccountViewHeaderSkeleton';
import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';

const AccountViewHeaderApp: FC = () => {
    const accountId = useAccountId();
    const { data: account, ...accountState } = useAccount(accountId);

    if (accountState.isLoading) {
        return (
            <div className="account-view-header skeleton">
                <AccountViewHeaderSkeleton />
            </div>
        );
    }

    return (
        <div className="account-view-header">
            <AccountViewHeader account={account} />
        </div>
    );
};

export default AccountViewHeaderApp;
